import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    standalone: true,
    selector: 'global-home-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['../../styles.scss', './badge.component.scss'],
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class BadgeComponent {
    @Input() packageName!: string | null;
}
